
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import { Sentry } from '@/plugins/sentry';

const venue = namespace('venue');

@Component({})
export default class FeedbackDialog extends Vue {
  @venue.State('active') public venue!: Venue;

  get hasSentryFeedback() {
    return !!process.env.VUE_APP_SENTRY_ENVIRONMENT;
  }

  public openDialog() {
    if (!this.hasSentryFeedback) {
      return;
    }

    Sentry.setTag('source', 'user-feedback');
    Sentry.setTag('feedback_channel', 'app-button');
    Sentry.setTag('route_name', `${this.$route?.name || 'unknown'}`);
    Sentry.setTag('venue_id', this.venue?._id || 'unknown');
    Sentry.setTag('venue_name', this.venue?.name || 'unknown');
    Sentry.setContext('feedback', {
      path: this.$route?.fullPath || '',
    });

    const feedbackIntegration = Sentry.getClient()?.getIntegrationByName?.('Feedback') as
      | { openDialog?: () => void }
      | undefined;

    feedbackIntegration?.openDialog?.();
  }
}
